import { MdArrowForward, MdCheckCircle } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

interface RegistrationBlockModalProps {
    onComplete: () => void
    missingFields: string[]
}

export default function RegistrationBlockModal({
    onComplete,
    missingFields,
}: RegistrationBlockModalProps) {
    const navigate = useNavigate()

    const handleGoToAccount = () => {
        navigate('/account')
        onComplete()
    }

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-base-100 rounded-lg shadow-2xl w-full !max-w-md mx-4 p-6 md:p-8">
                <div className="flex flex-col items-center text-center">
                    <div className="mb-4">
                        <div className="w-20 h-20 bg-secondary/10 rounded-full flex items-center justify-center">
                            <MdCheckCircle className="text-5xl text-secondary" />
                        </div>
                    </div>

                    <h2 className="text-2xl md:text-3xl font-bold text-base-content mb-2">
                        Bem-vindo ao MediarDex!
                    </h2>

                    <p className="text-base-content/70 mb-6 text-sm md:text-base">
                        Para continuar utilizando nossa plataforma, precisamos
                        que você complete seu cadastro pessoal e da sua empresa
                    </p>

                    <div className="w-full bg-base-200 rounded-lg p-4 mb-6">
                        <p className="text-sm text-base-content/80 font-medium mb-2">
                            Informações pendentes:
                        </p>
                        <ul className="text-left text-sm text-base-content/70 space-y-1">
                            {missingFields.map((field, index) => (
                                <li
                                    key={index}
                                    className="flex items-center gap-2"
                                >
                                    <span className="text-secondary">•</span>
                                    <span>{field}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <button
                        className="btn btn-secondary w-full gap-2"
                        onClick={handleGoToAccount}
                    >
                        Completar Cadastro
                        <MdArrowForward className="text-lg" />
                    </button>
                </div>
            </div>
        </div>
    )
}
